module.exports = {
  __depends__: [ require(162), require(224) ],
  __init__: [ 'bendpoints', 'bendpointSnapping' ],
  bendpoints: [ 'type', require(143) ],
  bendpointMove: [ 'type', require(140) ],
  connectionSegmentMove: [ 'type', require(144) ],
  bendpointSnapping: [ 'type', require(141) ]
};
